import { createAction, props } from '@ngrx/store';

export const saveEdiSearchDetails = createAction('[Edi Search Details] Save Data', props<{ payload: any }>());
export const resetEdiSearchDetails = createAction('[Dashboard Details] Reset');
